export default __webpack_public_path__ + "static/ain-group-726f40bea52dd32a2dcdc1d5967cbf4b.png";